import { useParams } from 'react-router-dom'

const byObject = {
  company: ({ id }) => `/companies/${id}`,
  person: ({ companyId, id }) => `/companies/${companyId}/borrowers/${id}`,
  draw: ({ companyId, personId, loanId, id }) =>
    `/companies/${companyId}/borrowers/${personId}/loans/${loanId}/draws/${id}`,
  supercase: ({ companyId, id }) =>
    companyId ? `/companies/${companyId}/supercases/${id}` : '',
}

const byPrefix = {
  LT: ({ companyId, id }) => `/companies/${companyId}/loan-types/${id}`,
  RL: ({ companyId, id }) => `/companies/${companyId}/roles/${id}`,
  BO: ({ companyId, id }) => `/companies/${companyId}/borrowers/${id}`,
  UR: ({ companyId, id }) => `/companies/${companyId}/users/${id}`,
  EM: ({ companyId, id }) => `/companies/${companyId}/employees/${id}`,
  TM: ({ companyId, id }) => `/companies/${companyId}/teams/${id}`,
  LN: ({ companyId, mainBorrowerId, id }) =>
    `/companies/${companyId}/borrowers/${mainBorrowerId}/loans/${id}`,
  TX: ({ companyId, loanId, mainBorrowerId, id }) =>
    `/companies/${companyId}/borrowers/${mainBorrowerId}/loans/${loanId}/transactions/${id}`,
  DD: ({ companyId, personId, id }) =>
    `/companies/${companyId}/borrowers/${personId}/documents/${id}`,
  CS: ({ companyId, personId, id }) =>
    `/companies/${companyId}/borrowers/${personId}/cases/${id}`,
  CT: ({ companyId, personId, id }) =>
    `/companies/${companyId}/borrowers/${personId}/contacts/${id}`,
  DP: ({ companyId, personId, loanId, drawId, id }) =>
    `/companies/${companyId}/borrowers/${personId}/loans/${loanId}/draws/${drawId}/purchases/${id}`,
  CE: ({ companyId, id }) => `/companies/${companyId}/case-types/${id}`,
  SC: ({ companyId, id }) => `/companies/${companyId}/supercases/${id}`,
  AP: ({ companyId, personId, loanId }) =>
    loanId && personId
      ? `/companies/${companyId}/borrowers/${personId}/loans/${loanId}/autopay`
      : '',
  WT: ({ companyId, id }) => `/companies/${companyId}/workflow-types/${id}`,
  AD: ({ companyId, id }) => `/companies/${companyId}/app-domains/${id}`,
}

const getLink = (item) => {
  const { id, object } = item || {}

  const prefix = id?.slice(0, 2)

  const fn = byObject[object] || byPrefix[prefix]

  if (fn) return fn(item)

  return ''
}

const useLink = (item, options = {}) => {
  const params = useParams()

  return getLink({ ...params, ...item, ...options })
}

export { useLink }

export default getLink
